import { render, staticRenderFns } from "./ProductPricing.vue?vue&type=template&id=147efb96&"
import script from "./ProductPricing.vue?vue&type=script&lang=ts&"
export * from "./ProductPricing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports